module.exports = __webpack_public_path__ + "static/media/SaltLakeCity.7b5f684a.jpg";